import { useTranslation } from '@/hooks/useTranslation';
import { StringDropdownItem, StringDropdownProps } from '@/components/generic/dropdown/StringDropdown.types';
import { SkeletonLoader } from '@/components/generic/loader/SkeletonLoader';
import { EnterpriseRoleEnum } from '@/graphql/generated';
import StringDropdown, { enumValuesToDropdownItems } from '@/components/generic/dropdown/StringDropdown';

export function UserRoleDropdown(
  props: Omit<StringDropdownProps<any>, 'availableItems'>,
) {
  const { t } = useTranslation();
  const loading = false;

  if (loading) {
    return <SkeletonLoader />;
  }

  const availableItems: StringDropdownItem[] = enumValuesToDropdownItems(
    EnterpriseRoleEnum,
    (key: string) => t(`enum:enterpriseRole.${key}`),
  );

  return (
    <div>
      <StringDropdown availableItems={availableItems} {...props} />
    </div>
  );
}

